<div class="dashboard-toolbar nav nav-pills">
  <li uib-dropdown>
    <a class="dropdown-toggle" uib-dropdown-toggle>
      Adicionar análise
      <span class="caret"></span>
    </a>
    <ul class="droppdown-menu" uib-dropdown-menu>
      <li ng-repeat="widget in widgetDefs">
        <a ng-click="addWidgetInternal($event, widget)">{{widget.title}}</a>
      </li>
    </ul>
  </li>
  <li ng-if="dashboard.saveEnabled(options.unsavedChangeCount)">
    <a ng-click="options.saveDashboard()" uib-tooltip="Há alterações pendentes" tooltip-placement="bottom" class="save-changes">
      <span class="glyphicon glyphicon-save"></span>
      Salvar alterações
    </a>
  </li>
  <li uib-dropdown>
    <a class="dropdown-toggle" uib-dropdown-toggle>
      {{$root.globalGleba ? 'Talhão '+$root.globalGleba.descricao : 'Talhão geral'}}
      <span class="caret"></span>
    </a>
    <ul class="dropdown-menu" uib-dropdown-menu>
      <li>
        <a ng-click="$root.globalGleba = null">Nenhuma</a>
      </li>
      <li ng-repeat="gleba in dashboard.glebas | orderBy: 'descricao' track by gleba.id">
        <a ng-click="$root.globalGleba = gleba">
          {{gleba.descricao}}
        </a>
      </li>
    </ul>
  </li>
  <li uib-dropdown>
    <a class="dropdown-toggle" uib-dropdown-toggle>
      {{$root.globalSafra ? 'Safra '+$root.globalSafra.descricao : 'Safra geral'}}
      <span class="caret"></span>
    </a>
    <ul class="dropdown-menu" uib-dropdown-menu>
      <li>
        <a ng-click="$root.globalSafra = null">Nenhuma</a>
      </li>
      <li ng-repeat="safra in $root.safras | orderBy: '-id' track by safra.id">
        <a ng-click="$root.globalSafra = safra">
          {{safra.descricao}}
        </a>
      </li>
    </ul>
  </li>
</div>
<div class="container-fluid dashboard-container">
  <div class="dashboard-widget-area" ui-sortable="sortableOptions" ng-model="widgets">
    <div ng-repeat="widget in widgets" ng-style="widget.containerStyle" widget class="widget-container">
      <div class="ibox widget" id="widget-{{$index}}">
        <div class="widget-header ibox-title">
          <h5>
            <span class="widget-title" ng-dblclick="editTitle(widget)" ng-hide="widget.editingTitle">{{widget.title}}</span>
            <form class="widget-title" ng-show="widget.editingTitle" ng-submit="saveTitleEdit(widget, $event)">
              <input type="text" ng-model="widget.title" ng-blur="titleLostFocus(widget, $event)" class="form-control">
            </form>
          </h5>
          <div class="ibox-tools hidden-print">
            <span prevent-default ng-print print-element-id="widget-{{$index}}">
              <a ng-click="dashboard.manageWidgetWidthOnPrint(widget, $event)" title="Imprimir" class="glyphicon glyphicon-print"></a>
            </span>
            <a ng-click="openWidgetSettings(widget)" title="Configurar" class="glyphicon glyphicon-cog" ng-if="!widget.hideWidgetSettings"></a>
            <a ng-click="removeWidget(widget)" title="Remover" class="glyphicon glyphicon-remove"></a>
          </div>
        </div>
        <div class="ibox-content widget-content" ng-style="widget.contentStyle"></div>
        <div class="widget-w-resizer">
          <div class="nw-sizer" ng-if="widget.enableVerticalResize" ng-mousedown="grabResizer($event, 'nw')"></div>
          <div class="ew-sizer" ng-mousedown="grabResizer($event, 'w')"></div>
          <div class="sw-sizer" ng-if="widget.enableVerticalResize" ng-mousedown="grabResizer($event, 'sw')"></div>
        </div>
        <div class="widget-e-resizer">
          <div class="ne-sizer" ng-if="widget.enableVerticalResize" ng-mousedown="grabResizer($event, 'ne')"></div>
          <div class="ew-sizer" ng-mousedown="grabResizer($event, 'e')"></div>
          <div class="se-sizer" ng-if="widget.enableVerticalResize" ng-mousedown="grabResizer($event, 'se')"></div>
        </div>
      </div>
    </div>
  </div>
</div>
